import getFilters from 'components/Filters';
import { MENTOR_PRIORITY_LEVELS, priorityLevels } from 'enums/PriorityLevels';
import { FC, useContext } from 'react';
import {
  considerationColumn,
  diplomaColumn,
  expertiseFieldsColumn,
  formationsColumn,
  getCareerPlanColumn,
  getEntrepreneurshipColumn,
  getStudiesColumn,
  hobbyColumn,
  wantedMentorshipsColumn,
} from 'utils/tagColumns';
import { MenteeAssociateContext, TagColumnNames } from '.';

const Filters = getFilters<TagColumnNames>();
const MentoringFilter: FC = () => {
  const { search, setSearch, tags, setTags, take, setTake } = useContext(
    MenteeAssociateContext,
  );

  return (
    <Filters
      tagList={[
        {
          columnName: 'jobSearch',
          columnTitle: "Recherche d'emploi",
          tags: priorityLevels.map((priorityLevel) => ({
            name: priorityLevel,
            label: MENTOR_PRIORITY_LEVELS[priorityLevel],
          })),
        },
        getCareerPlanColumn('mentor'),
        getStudiesColumn('mentor'),
        getEntrepreneurshipColumn('mentor'),
        expertiseFieldsColumn,
        formationsColumn,
        diplomaColumn,
        considerationColumn,
        hobbyColumn,
        wantedMentorshipsColumn,
      ]}
      state={{ tags, search, take }}
      setTags={setTags}
      setSearch={setSearch}
      setTake={setTake}
    />
  );
};

export default MentoringFilter;
